import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import "./dashboard.css";
// import { InPageSearch } from "../modules/Static";

export default function Dashboard({ isMenuRight, menu, children }) {
  // const menuMarkup = (
  //   <div style={{display: "flex", flexDirection: "column"}}>
  //     {/* <InPageSearch containerId="currentStaticPage" /> */}
  //     {menu}
  //   </div>
  // );
  return (
    <div className="neg-margin-lr">
      <div className="w3-row">
        <div
          id={isMenuRight ? "dashboard-content" : "dashboard-menu"}
          className={classnames("pad-lr", {
            "w3-col": !isMenuRight,
            "w3-rest": isMenuRight,
            "dashboard-menu": !isMenuRight,
          })}
        >
          {isMenuRight ? children : menu} &nbsp;
        </div>
        <div
          id={!isMenuRight ? "dashboard-content" : "dashboard-menu"}
          className={classnames("pad-lr", {
            "w3-col": isMenuRight,
            "w3-rest": !isMenuRight,
            "dashboard-menu": isMenuRight,
          })}
        >
          {isMenuRight ? menu : children} &nbsp;
        </div>
      </div>
    </div>
  );
}

Dashboard.propTypes = {
  isMenuRight: PropTypes.bool,
  menuSize: PropTypes.number,
  menu: PropTypes.node,
  children: PropTypes.node,
};
Dashboard.defaultProps = {
  menuSize: 4,
};
